import React from 'react';
const LocationPinIcon = ({ width = 10, height = 14 }) => {
    return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("g", { "clip-path": "url(#clip0_60388_145059)" },
            React.createElement("path", { d: "M12 5.3335C12 7.02288 9.66079 11.3917 8.56007 13.3539C8.31151 13.797 7.68849 13.797 7.43993 13.3539C6.33921 11.3917 4 7.02288 4 5.3335C4 3.12436 5.79086 1.3335 8 1.3335C10.2091 1.3335 12 3.12436 12 5.3335Z", stroke: "#6E6E77", "stroke-width": "1.5" }),
            React.createElement("circle", { cx: "8", cy: "5.3335", r: "1.25", stroke: "#6E6E77", "stroke-width": "1.5" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0_60388_145059" },
                React.createElement("rect", { width: "16", height: "16", fill: "white" })))));
};
export default LocationPinIcon;
